import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBulb = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2a.75.75 0 0 1 .75.75v2.236a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 12 2M5.584 4.346a.75.75 0 0 1 1.06.011l1.561 1.595a.75.75 0 1 1-1.072 1.05l-1.56-1.596a.75.75 0 0 1 .01-1.06M18.416 4.346a.75.75 0 0 1 .012 1.06l-1.562 1.595a.75.75 0 0 1-1.072-1.049l1.562-1.595a.75.75 0 0 1 1.06-.011M2 9.503a.75.75 0 0 1 .75-.75h2.21a.75.75 0 1 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M18.29 9.503a.75.75 0 0 1 .75-.75h2.21a.75.75 0 0 1 0 1.5h-2.21a.75.75 0 0 1-.75-.75"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.891 8.246a5.86 5.86 0 0 0-5.994.125 5.94 5.94 0 0 0-2.119 2.291 6.02 6.02 0 0 0 .27 6.039 5.9 5.9 0 0 0 1.904 1.86v2.142c.01.344.15.673.397.916s.58.381.928.381h3.446c.348 0 .681-.138.928-.38.247-.244.388-.573.396-.918v-2.187a5.94 5.94 0 0 0 1.957-1.941c.576-.93.888-2 .901-3.097v-.006a6 6 0 0 0-.802-3.025 5.94 5.94 0 0 0-2.212-2.2m-2.982.736a4.36 4.36 0 0 0-2.218.662 4.44 4.44 0 0 0-1.583 1.713 4.52 4.52 0 0 0 .202 4.533 4.4 4.4 0 0 0 1.73 1.56.75.75 0 0 1 .412.67v2.38h3.096v-2.425a.75.75 0 0 1 .412-.67 4.43 4.43 0 0 0 1.77-1.622 4.5 4.5 0 0 0 .675-2.32 4.5 4.5 0 0 0-.602-2.268 4.44 4.44 0 0 0-1.652-1.645 4.36 4.36 0 0 0-2.242-.568"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBulb;
